import styled from 'styled-components';
import { size } from '../../../styled/layout/helpers';
import { theme } from '../../../styled/layout/theme';

export const Wrapper = styled.div`
  display: flex;
  padding: ${size(8)} 0;
  flex-direction: column;
  align-items: center;
`;

export const CountdownItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 ${size(2)};
`;

export const Digit = styled.span`
  font-size: ${size(6)};
  font-weight: 500;

  ${theme.screens.LtMd} {
    font-size: ${size(4)};
  }
`;

export const Unit = styled.span`
  font-size: ${size(3)};
  line-height: 1;

  ${theme.screens.LtMd} {
    font-size: ${size(2)};
  }
`;

export const Countdown = styled.div`
  display: flex;
  justify-content: center;
  font-family: ${theme.font.family.brand};

  &.pending ${Digit} {
    visibility: hidden;
  }
`;

export const EndMessage = styled.span`
  font-size: ${size(6)};
  font-weight: 500;
  font-family: ${theme.font.family.brand};

  ${theme.screens.LtMd} {
    font-size: ${size(4)};
  }
`;
